import { useState } from "react";
import { LuLoaderCircle, LuRotateCcw, LuX } from "react-icons/lu";
import { colors, typography, effects } from "../../../design/tokens";
import { useChatMessagesActions } from "../../../view_stores/chat_messages/useChatMessagesStore";
import { HttpAssistantIsWorkingException } from "../../../model/httpException";
import { useSnackbar } from "../../../providers/SnackbarProvider";
import { useRollbackHandlerActions } from "../../../view_stores/useRollbackHandlerStore";

export default function ProjectRollbackConfirmation() {
  const { rollbackConfirmed, reset } = useRollbackHandlerActions();
  const { setShouldAutoScroll } = useChatMessagesActions();
  const { showSnackbar } = useSnackbar();

  const [isRollbacking, setIsRollbacking] = useState(false);

  return (
    <div className={`border ${effects.borderRadius.xl} border-dark-border p-6`}>
      <div className="flex flex-col items-center gap-6">
        <div className={`flex flex-col gap-2 ${typography.size.base} ${colors.text.primary} leading-[1.6]`}>
          <p>
            All changes made after the selected checkpoint will be permanently
            lost and cannot be recovered.
          </p>
          <p className={typography.weight.medium}>Proceed with revert?</p>
        </div>
        <div className="flex justify-center gap-8 w-full max-w-[400px]">
          <button
            className={`w-full flex items-center justify-center
                gap-2 py-2 bg-dark-surface-secondary
                ${colors.hover.brightness} hover:cursor-pointer
                ${effects.transition.default} ${effects.borderRadius.md}
                ${typography.size.sm} ${colors.text.secondary}`}
            onClick={reset}
            disabled={isRollbacking}
          >
            <LuX />
            <span>Cancel</span>
          </button>
          <button
            className={`w-full flex items-center justify-center
            gap-2 py-2 bg-primary-blue
            ${colors.hover.brightness} hover:cursor-pointer
            ${effects.transition.default} ${effects.borderRadius.md}
            ${typography.size.sm} text-white`}
            onClick={async () => {
              try {
                setIsRollbacking(true);
                await rollbackConfirmed();
                setShouldAutoScroll(true);
              } catch (error) {
                setIsRollbacking(false);
                if (error instanceof HttpAssistantIsWorkingException) {
                  showSnackbar(
                    "Previous action is still in progress, try again later.",
                    {
                      type: "error",
                      duration: 5000,
                    }
                  );
                } else {
                  throw error;
                }
              }
            }}
            disabled={isRollbacking}
          >
            {isRollbacking ? (
              <LuLoaderCircle className="animate-spin" size={20} />
            ) : (
              <>
                <LuRotateCcw />
                <span>Revert now</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
